import { Route } from 'react-router-dom';

import { lazyImport } from 'utils/lazyImport';

import { LeaWrapper } from './components/LeaWrapper';

const { LeaQuestionnaireForm } = lazyImport(
  () => import('./pages/LeaQuestionnaire/LeaQuestionnaireForm'),
  'LeaQuestionnaireForm'
);
const { LeaList } = lazyImport(() => import('./components/LeaList'), 'LeaList');

const { LeaListPage } = lazyImport(() => import('./pages/LeaListPage'), 'LeaListPage');

export const leaConfigRoutes = (
  <Route path="/">
    <Route index element={<LeaListPage />} />
    <Route path=":leaId" element={<LeaWrapper />}>
      <Route index element={<LeaList />} />
      <Route path="new" element={<LeaQuestionnaireForm />} />
      <Route path=":id/edit" element={<LeaQuestionnaireForm />} />
    </Route>
  </Route>
);
